import * as React from 'react';
import {Link} from 'react-router-dom';
import './styles.sass';

interface IAccordionItemTitleProps {
  link: string;
  onClick: () => void;
}

export const AccordionItemTitle: React.StatelessComponent<IAccordionItemTitleProps> = ({
  children,
  onClick,
  link,
}) => (
  <Link
    className={'accordion-item-title'}
    onClick={onClick}
    to={link}
  >
    {children}
  </Link>
);
